import React, { useContext } from "react";
import Sheet from "@mui/joy/Sheet";
import Box from "@mui/joy/Box";
import Avatar from "@mui/joy/Avatar";
import Grid from "@mui/joy/Grid";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import { ChatContext } from "./mensajecontext";
import CircleIcon from "@mui/icons-material/Circle";

export default function TarjetachatUsuario({
  nombre,
  foto,
  interes_personal,
  ultimomensaje,
  edad,
  funcion,
  leido,
}) {
  const { ocultarDisenoChat } = useContext(ChatContext);

  /* Calcula Edad */
  const calcularEdad = (fechaNacimiento) => {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    const edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      return edad - 1;
    }
    return edad;
  };
  /* Calcula Edad*/

  let almacenamientoURL = process.env.REACT_APP_DOSPACES;

  return (
    <div>
      <Box
        sx={{ width: "100%" }}
        onClick={() => {
          funcion();
          ocultarDisenoChat();
        }}
      >
        <Sheet
          variant="outlined"
          sx={{
            p: 2,
            boxShadow: "sm",
            display: "flex",
            alignItems: "center",
            gap: 0,
            cursor: "pointer",
            borderRight: 0,
            borderLeft: 0,
            borderTop: 0,
            "&:hover": {
              backgroundColor: "neutral.softBg",
            },
          }}
        >
          <Box sx={{ display: "grid", gap: 2 }}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              <Avatar
                src={`${almacenamientoURL}/uploads/${foto}`}
                alt={`${nombre}`}
              />
              <Box sx={{ display: "grid" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography level="title-sm">
                    {nombre}, {calcularEdad(edad)}
                  </Typography>
                  {leido ? null : (
                    <CircleIcon sx={{ fontSize: 8, color: "#FA812F" }} />
                  )}
                </Box>

                <Box sx={{ display: "flex", gap: 0.5 }}>
                  <Typography level="body-xs">{interes_personal[0]}</Typography>
                </Box>
              </Box>
            </Box>
            {false ? (
              <Typography level="body-sm">
                Sabes que el otro dia me encontre un perrito...
              </Typography>
            ) : null}
          </Box>
        </Sheet>
      </Box>
    </div>
  );
}
